import { getPartnerId } from '../helpers/common';

interface EventProperties {
  partnerId?: string;
  [key: string]: any;
}

export const pushClevertapEvent = (eventName: string, properties: EventProperties = {}) => {
  if (typeof window === "undefined") return;

  const clevertap = (window as any).clevertap;

  if (!clevertap?.event) {
    console.warn("CleverTap is not initialized yet.");
    return;
  }

  // Merge properties efficiently
  const eventProperties = { partnerId: properties.partnerId ?? getPartnerId(), ...properties };

  // Push event safely
  try {
    clevertap.event.push(eventName, eventProperties);
    console.log(`%cCleverTap Event Triggered: ${eventName}`, "color:orange;font-weight:bold", eventProperties);
  } catch (error) {
    console.error("%cFailed to push CleverTap event:", "color:red;font-weight:bold", error);
  }
};
